var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"size":50,"color":"rgb(47, 66, 85)","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }